import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlogCard from "./BlogCard";
import { apiUrl, brands } from "../../config/config";
import SEO from "../SEO";
import BlogListSkeleton from "./BlogListSkeleton";
const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/${brands}/blogs`)
      .then(res => res.json())
      .then(res => {
        setBlogs(res.data);

        // 👉 last 5 blogs as recent
        setRecentBlogs(res.slice(0, 5));

        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

if (loading) {
  return <BlogListSkeleton />;
}

  return (
    <>
             <SEO
        title="Custom Patches Manufacturer | Your Brand"
        description="Order custom embroidered, PVC & woven patches with fast delivery."
        keywords="custom patches, embroidered patches, pvc patches"
      />
    <div className="max-w-7xl mx-auto px-4 py-12">

      <h2 className="text-3xl font-bold text-center mb-10">
        Latest Blogs
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

        {/* ======================
            BLOG GRID
        ======================= */}
        <div className="md:col-span-3">
          {blogs.length === 0 ? (
            <p className="text-center text-gray-500">
              No blogs found.
            </p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {blogs.map(blog => (
                <BlogCard key={blog.id} blog={blog} />
              ))}
            </div>
          )}
        </div>

        {/* ======================
            RECENT BLOGS SIDEBAR
        ======================= */}
        <div className="md:col-span-1">

          <div className="bg-white rounded-lg shadow p-4 sticky top-24">

            <h3 className="text-lg font-bold mb-4">
              Recent Blogs
            </h3>

            {recentBlogs.length === 0 ? (
              <p className="text-sm text-gray-500">
                No recent blogs
              </p>
            ) : (
              <div className="space-y-4">
                {recentBlogs.map(blog => (
                  <Link
                    key={blog.id}
                    to={`/blogs/${blog.slug}`}
                    className="flex gap-3 hover:bg-gray-100 p-2 rounded transition"
                  >
                    {blog.image && (
                      <img
                        src={`${apiUrl}/storage/${blog.image}`}
                        alt={blog.title}
                        className="w-14 h-14 object-cover rounded"
                      />
                    )}

                    <div>
                      <p className="text-sm font-semibold leading-snug">
                        {blog.title}
                      </p>
                      <span className="text-xs text-gray-500">
                        {blog.category?.name}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
    </>
  );
};

export default BlogList;
